import React from 'react';

class Footer extends React.Component {
  render() {
    return (
      <footer>Desenvolvido por: Raynara Santiago</footer>
    );
  }
}

export default Footer;
